module.exports = __webpack_public_path__ + "static/img/91-2.fa47b2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/91-2.jpg
// module id = pNje
// module chunks = 0